// ---------------------------------------------------------------------------
// Equipe da clínica. Para adicionar a foto profissional, salve a imagem em
// /app/frontend/public/images/ e preencha o campo `photo` (ex.: "/images/dra-gabriella.jpg").
// Enquanto `photo` estiver vazio, o site exibe um avatar com as iniciais.
// ---------------------------------------------------------------------------
export const TEAM = [
  {
    id: "gabriella-oliveira-campos",
    name: "Dra. Gabriella Oliveira Campos",
    initials: "GO",
    cro: "CRO/MG 73220",
    role: "Cirurgiã-dentista",
    bio: "Atendimento acolhedor e planejamento individualizado, com foco em saúde bucal e estética natural.",
    photo: "",
  },
  {
    id: "raylla-luise-ramos",
    name: "Dra. Raylla Luise Ramos",
    initials: "RR",
    cro: "CRO/MG 73207",
    role: "Cirurgiã-dentista",
    bio: "Cuidado detalhista em cada etapa do tratamento, unindo técnica, conforto e escuta atenta.",
    photo: "",
  },
];
